module.exports = __webpack_public_path__ + "media/images/illustration/undraw_house_searching_n8mp-093e4fcd56f2fb8a67757b966c471cbd.svg";